<template>
  <el-dialog title="发证" :visible.sync="showDialog" append-to-body width="50%">
    <el-form :model="ruleForm" size="small" :rules="rules" ref="ruleForm" label-width="80px">
      <el-form-item label="发送方式" prop="type">
        <el-checkbox-group v-model="ruleForm.type" @change="checkboxChange">
          <el-checkbox-button label="0" name="type">邮件通知</el-checkbox-button>
          <el-checkbox-button label="1" name="type">手机短信通知</el-checkbox-button>
          <el-checkbox-button label="2" name="type">线下发送快递</el-checkbox-button>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="快递公司" v-if="showKD" prop="shipperName">
      <el-select size="small" v-model="ruleForm.shipperName" clearable placeholder="请选择">
        <el-option
          v-for="item in kuaidiOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="物流单号" v-if="showKD" prop="logisticCode">
      <el-input size="small" v-model="ruleForm.logisticCode">
      </el-input>
    </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="submitForm('ruleForm')">确定</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
  data() {
    return {
      showDialog: false,
      ruleForm: {
        phone: '',
        type: [],
        shipperName: '', // 快递公司
        logisticCode: '', // 物流单号
      },
      rules: {
        type: [
          { required: true, message: '请选择发证方式', trigger: 'change' }
        ],
        shipperName: [
          { required: true, message: '请选择快递公司', trigger: 'change' }
        ],
        logisticCode: [
          { required: true, message: '请输入物流单号', trigger: 'blur' }
        ],
      },
      kuaidiOptions: [
        {
          value: "zhongtong",
          label: "中通快递",
        },
        {
          value: "yuantong",
          label: "圆通速递",
        },
        {
          value: "yunda",
          label: "韵达快递",
        },
        {
          value: "shentong",
          label: "申通快递",
        },
        {
          value: "shunfeng",
          label: "顺丰速运",
        },
        {
          value: "huitongkuaidi",
          label: "百世快递",
        },
        {
          value: "jd",
          label: "京东物流",
        },
        {
          value: " youzhengguonei",
          label: "邮政快递包裹",
        },
        {
          value: "youzhengbk",
          label: "邮政标准快递",
        },
        {
          value: "ems",
          label: "EMS",
        },
      ],
      showKD: false,
      reqData: [
        // {
        //   type: 0,
        //   addresseeList: []
        // },
        // {
        //   type: 1,
        //   phoneList: []
        // },
        // {
        //   type: 2,
        //   shipperName: '', 
        //   logisticCode: ''
        // }
      ]
    }
  },
  computed: {
    ...mapGetters({
      storePersonList: "case/personList", // 当事人
    })
  },
  mounted() {

  },
  methods: {
    open() {
      this.showDialog = true;
    },
    close() {
      this.showDialog = false;
    },
    confirmAcceptance() {
      console.log(this.currCaseId);
      this.close();
    },
    checkboxChange(e) {
      if (e.indexOf('2') !== -1) {
        this.showKD = true;
      } else {
        this.showKD = false;
      }
    },
    // 表单提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.reqData = [];
          // console.log(this.storePersonList);
          this.ruleForm.type.forEach(item => {
            if (item === '0') {
              let obj = {};
              obj.type = '0';
              obj.addresseeList = [];
              this.storePersonList.forEach(i => {
                obj.addresseeList.push(i.email);
              });
              this.reqData.push(obj);
            }
            if (item === '1') {
              let obj = {};
              obj.type = '1';
              obj.phoneList = [];
              this.storePersonList.forEach(i => {
                obj.phoneList.push(i.phone);
              });
              this.reqData.push(obj);
            }
            if (item === '2') {
              let obj = {};
              obj.type = '2';
              obj.shipperName = this.ruleForm.shipperName;
              obj.logisticCode = this.ruleForm.logisticCode;
              this.reqData.push(obj);
            }
          })
          console.log(this.reqData);
          this.$emit('sendCre', this.reqData);
          this.close();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  }
}
</script>
<style lang="less" scoped>

/deep/ .el-input{
  width: 202px;
}
</style>